import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import moment from "moment-jalaali";
import { Flight as FlightURL, Header, ServerAddress } from "../../Enum/Urls";
import airplane from "../../image/airplane.svg";
import Price from "../Common/Price";
import { Collapse, Button,Tag } from "antd";
import { showError } from "../../Actions/VisualDataAction";
import { connect } from "react-redux";
import _ from "lodash";
import FlightItinerary from "./FlightItinery";
import Back from "../Common/Back";
import LayoutConfig from "../../Config/layoutConfig";
import { showDuration } from "../../helpers/helpers";

class FlighSummary extends React.PureComponent {
  state = {
    showItinerariModal: false,
    activeTab: "flightItinery",
    showRules: false,
    rulesContent: null,
    domesticRefundRules:null
  };
  componentDidUpdate(prevProps) {
    if(this.props.detailsIsOpen && prevProps.detailsIsOpen!== this.props.detailsIsOpen){
        this.openItinerariModal();
    }
  }
  openItinerariModal = () => {
    this.setState({
      showItinerariModal: true,
    });
  };
  closeItinerariModal = () => {
    this.setState({
      showItinerariModal: false,
    });
    if(this.props.closeDetailsModal){
      this.props.closeDetailsModal();
    }
  };
  static propTypes = {
    model: PropTypes.any.isRequired,
    fareInfo: PropTypes.any.isRequired,
    totalPrice: PropTypes.any.isRequired,
    currencyCode: PropTypes.any.isRequired,
    showButton: PropTypes.any.isRequired,
  };

  showPassenger(cnt, type, price) {
    const { Dictionary } = this.props;
    return (
      <div className={"pair-row"}>
        <div className="passenger-type-title">
          {cnt} <span> x </span>
          {type === "ADT" && Dictionary.adult}
          {type === "CHD" && Dictionary.child}
          {type === "INF" && Dictionary.infant}
        </div>
        <div dir="ltr">
          <Price currency={this.props.currencyCode}>{price}</Price>
        </div>
      </div>
    );
  }
  showEachPassenger (index,type, extraBaggage) {
    const { Dictionary } = this.props;
    const { Panel } = Collapse;
    const passengerItemFare = this.props.fareInfo.filter(item=> item.passengerTypeQuantity.code === type)[0].passengerFare;
    return (
      <Panel
        className="PassengerType"
        header={
          <div className={"pair-row"}>
            <div className="passenger-type-title">
              {Dictionary.passenger} <span> {index+1} </span>
              ({type === "ADT" ? Dictionary.adult
              :type === "CHD" ? Dictionary.child
              :type === "INF" ? Dictionary.infant
              :type})
            </div>
            <div dir="ltr">
              <Price currency={this.props.currencyCode}>{extraBaggage ? passengerItemFare.totalFareWithExtraBaggage:passengerItemFare.totalFare }</Price>
            </div>
          </div>
        }
        key={index}
      >
        <div className="pair-row baseFare gray">
          <div>{Dictionary.baseFare}: </div>
          <div dir="ltr">
            <Price currency={this.props.currencyCode}>
              {passengerItemFare.baseFare}
            </Price>
          </div>
        </div>
        <div className="pair-row taxes gray">
          <div>{Dictionary.taxes}:</div>
          <div dir="ltr">
            <Price currency={this.props.currencyCode}>
              {passengerItemFare.totalTaxes
                ? passengerItemFare.totalTaxes
                : _.sumBy(
                  passengerItemFare.taxes,
                    (item) => item.amount
                  )}
            </Price>
          </div>
        </div>

        {extraBaggage ? <div className="pair-row baseFare gray">
          <div>{Dictionary.extraBaggage}: </div>
          <div dir="ltr">
            <Price currency={this.props.currencyCode}>
              {passengerItemFare.extraBaggage}
            </Price>
          </div>
        </div>:null}
      </Panel>

    );  
  }

  getRules = (key) => {
    axios({
      method: "get",
      url: `${ServerAddress.Type}${ServerAddress.Flight}${FlightURL.GetRules}`,
      params: { key },
      headers: { ...Header },
    })
      .then((response) => {
        this.setState({
          rulesContent: response.data.result,
        });
      })
      .catch((error) => {
        try {
          this.props.showError({
            visibility: true,
            content: error.response.data.error.message,
          });
        } catch (e) {
          console.error("e-3");
          this.props.showError({
            visibility: true,
            content: "Internal Error,Please refresh the page",
          });
        }
      });
  };

  
  getDomesticRefundRules = (key) => {
    axios({
      method: "get",
      url: `${ServerAddress.Type}${ServerAddress.Flight}${FlightURL.GetDomesticRefundRules}`,
      params: { key },
      headers: { ...Header },
    })
      .then((response) => {
        this.setState({
          domesticRefundRules: response.data.result,
        });
      })
      .catch((error) => {
        try {
          this.props.showError({
            visibility: true,
            content: error.response.data.error.message,
          });
        } catch (e) {
          console.error("e-4");
          this.props.showError({
            visibility: true,
            content: "Internal Error,Please refresh the page",
          });
        }
      });
  };
    
  toggleDetails = () => {
    this.setState((prevstate) => {
      return {
        showDetails: !prevstate.showDetails,
      };
    });
  };
  toggleRules = (value) => {
    if (value) {
      this.getRules(this.props.supplierKey);
    }
  };
  tabClick = (item) => {
    this.setState({
      activeTab: item,
    });
    if (item === "flightRules") {
      if (!this.state.rulesContent){
        this.toggleRules(true);
      }
    }
    if (item === "domesticRefundRules") {
      if (!this.state.domesticRefundRules){
        this.getDomesticRefundRules(this.props.supplierKey);
      }
    }
  };

  render() {
    const { Dictionary, LAN } = this.props;
    const { Panel } = Collapse;
    const flightType = this.props.flightType ? <Tag
      className="margin-end"
      color={this.props.model.flightType === "Systemic" ? "purple" : "orange"}
    >
      {this.props.flightType === "Systemic" ?
        Dictionary.Systemic
        : this.props.flightType === "Charter" ?
          Dictionary.Charter
          : this.props.flightType}
    </Tag> : null;

    let noBaggageElement = null;   
    this.props.model?.forEach((item) => {
      item.flightSegments.forEach(segmentItem => {
        segmentItem.baggageInformation.filter(x=>x.passengerType !== "INF").forEach((baggageItem) => {
          if (baggageItem.baggageAllowance < 1) {
            noBaggageElement = <span className='purple'><span className='itours-icon red-no-baggage margin-end-light' />{Dictionary.noBaggage}</span>;
          }
        });
      });
    });

    const isStyle3 = LayoutConfig.themeClassName === 'style-3';

    return (
      <div className="ticket-style-holder">
        <div className="ticket-style-section">
          <div className="hr_padding clearfix">
            <button
              className={`button ${isStyle3?"yellow-btn":"blue-btn"} pull-end ${this.props.hasBackLink?"medium-btn":""}`}
              type="button"
              onClick={this.openItinerariModal}
            >
              {Dictionary.flightDetails}
            </button>
            
            {!!this.props.hasBackLink &&  <Back text={Dictionary.changeFlight} />}

            <h5 className="normal-title">{Dictionary.selectedFlight}</h5>
              {/* {
              (this.props.supplierKey && (this.props.supplierKey.slice(0, 3) === "009") )
              ||
              (this.props.providerName && (this.props.providerName ==="TravelFusion") )
              ?
                <>
                <Tag color="red" className="itours-tag font-16">{Dictionary.nonChangeable}</Tag>
                  <Tag color="red" className="itours-tag font-16">{Dictionary.nonRefundable}</Tag>
                </>
              :
                null
              } */}
            <div className="selected-flights-info">
              {this.props.model.map((item) => {
                return (
                  <div
                    className="margin-bottom-light"
                    key={item.flightSegments[0].flightNumber}
                  >
                    <div>
                      <strong className="font-14 margin-end-light">
                        {moment(
                          item.flightSegments[0].departureDateTime
                        ).format("YYYY-MM-DD")}
                      </strong>
                      {LAN === "IR" ? (
                        <span className="font-12">
                          (
                          {moment(
                            item.flightSegments[0].departureDateTime
                          ).format("jYYYY-jMM-jDD")}
                          )
                        </span>
                      ) : null}
                    </div>
                    <div className="route-item">
                      <div className="route-item-flex">
                        <div className="airline-logo-holder summery-airline-logo">
                          <img
                            src={
                              item.flightSegments[0].marketingAirline.photoUrl
                            }
                            alt={item.flightSegments[0].marketingAirline.name}
                            className="airline-logo"
                          />
                        </div>
                        <div>
                          <div className="router">
                            <div className="originInfo">
                              <div className="time">
                                <strong>
                                  {moment(
                                    item.flightSegments[0].departureDateTime
                                  ).format("HH:mm")}
                                </strong>
                              </div>
                              <div className="codeCity">
                                {
                                  item.flightSegments[0].departureAirport
                                    .locationCode
                                }
                              </div>
                            </div>
                            <div className="stop-info text-center">
                              <div className="stop">
                                {item.flightSegments.length - 1 === 0 ? (
                                  <span className={isStyle3?"golden":"green"}>
                                    {Dictionary.direct}
                                  </span>
                                ) : (
                                  <span>
                                    {item.flightSegments.length - 1}{" "}
                                    {Dictionary.stops}
                                  </span>
                                )}
                              </div>
                              <div className="dashed-line">
                                {" "}
                                <img
                                  src={airplane}
                                  alt="airplane"
                                  title={"airplane"}
                                />
                              </div>
                              <div className="duration">
                                {Dictionary.journeyDuration} <span className="no-wrap"> {showDuration(item.journeyDuration)} </span>
                              </div>
                            </div>
                            <div className="destinationInfo text-end">
                              <div className="time">
                                <strong>
                                  {(item.flightSegments[item.flightSegments.length-1].arrivalDateTime === '0001-01-01T00:00:00')?"-- : --": moment(
                                    item.flightSegments[
                                      item.flightSegments.length - 1
                                    ].arrivalDateTime
                                  ).format("HH:mm")}
                                </strong>
                              </div>
                              <div className="codeCity">
                                {
                                  item.flightSegments[
                                    item.flightSegments.length - 1
                                  ].arrivalAirport.locationCode
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className={`itours-modal ${this.state.showItinerariModal ? "visible" : ""}`} >
          <div className="modal-overlay" onClick={this.closeItinerariModal} />
          <div className="modal-inner">
            {this.props.showFlightAllDetails ?null:<div className="modal-header">{Dictionary.flightDetails}</div>}
            <div className={`modal-main ${this.props.showFlightAllDetails?"no-padding":""}`}>
              <div className="flightDetails">
                <div className="detail-flight">
                  {this.props.showFlightAllDetails?
                  //---------start
                  <div className="flight-detail-main">
                      <div className="itours-tab-holder">
                        <div className="itours-tab-list">
                          <button
                            type="button"
                            className={
                              this.state.activeTab === "flightItinery"
                                ? "itours-tab-btn active"
                                : "itours-tab-btn"
                            }
                            onClick={() => this.tabClick("flightItinery")}
                          >
                            {Dictionary.flightItinery}
                          </button>
                          <button
                            type="button"
                            className={
                              this.state.activeTab === "baggageInfo"
                                ? "itours-tab-btn active"
                                : "itours-tab-btn"
                            }
                            onClick={() => this.tabClick("baggageInfo")}
                          >
                            {Dictionary.baggageInfo}
                          </button>
                          <button
                            type="button"
                            className={
                              this.state.activeTab === "flightFare"
                                ? "itours-tab-btn active"
                                : "itours-tab-btn"
                            }
                            onClick={() => this.tabClick("flightFare")}
                          >
                            {Dictionary.flightFare}
                          </button>

                          {!this.props.supplierKey? null
                          :this.props.isDomestic && (process.env.REACT_APP_SERVER_LOCALSERVER === "santana.imt.as" || process.env.REACT_APP_SERVER_LOCALSERVER ==="itours.ir")?<button type="button" 
                            className={`itours-tab-btn ${this.state.activeTab === "domesticRefundRules"?"active":""}`}
                            onClick={() => this.tabClick("domesticRefundRules")}
                          >
                            قوانین استرداد
                          </button>
                          :
                          <button 
                            type="button"
                            className={`itours-tab-btn ${this.state.activeTab === "flightRules"?"active":""}`}
                            onClick={() => this.tabClick("flightRules")}
                          >
                            {Dictionary.flightRules} 
                          </button>
                          }

                        </div>
                        <div className="itours-tab-contents">
                          {this.state.activeTab === "flightItinery" ? (
                            <div className="detail-flight">
                              <FlightItinerary model={this.props.model} />
                            </div>
                          ) : (
                            false
                          )}
                          {this.state.activeTab === "baggageInfo" ? (
                            <div className="flight-baggage-detail">
                              {this.props.model.map((item) => {
                                return (
                                  <div
                                    className="detail-flight-item "
                                    key={item.flightSegments[0].flightNumber}
                                  >
                                    {item.flightSegments.map((item, index) => {
                                      return (
                                        <div
                                          className="baggegesInformation"
                                          dir="ltr"
                                          key={index}
                                        >
                                          <div className="text-left">
                                            <div>
                                              <b>{item.departureAirport.cityName}</b> -{" "}
                                              <small>
                                                {item.departureAirport.countryName}
                                              </small>
                                            </div>
                                          </div>
                                          <div className={"airplaneIcon"}>
                                            <img
                                              src={airplane}
                                              alt={"airplane"}
                                              title={"airplane"}
                                            />
                                          </div>
                                          <div className="text-left">
                                            <div>
                                              <b>{item.arrivalAirport.cityName}</b> -{" "}
                                              <small>
                                                {item.arrivalAirport.countryName}
                                              </small>
                                            </div>
                                          </div>
                                          <div>
                                            {item.baggageInformation.map(
                                              (baggageItem, baggageIndex) => (
                                                <div key={baggageIndex}>
                                                  {baggageItem.baggageAllowance}{" "}
                                                  {baggageItem.unitType}{" "}
                                                  {this.props.hasExtraBaggage && <span>(
                                                    +{item.extraBaggageInformation.filter(x=>x.passengerType === baggageItem.passengerType)[0].baggageAllowance}  {baggageItem.unitType}{" "} {Dictionary.extraBaggage}
                                                  )</span>}
                                                  <span> {Dictionary.for} </span>
                                                  {baggageItem.passengerType === "ADT" && (
                                                    <span>{Dictionary.adult}</span>
                                                  )}
                                                  {baggageItem.passengerType === "CHD" && (
                                                    <span>{Dictionary.child}</span>
                                                  )}
                                                  {baggageItem.passengerType === "INF" && (
                                                    <span>{Dictionary.infant}</span>
                                                  )}
                                                </div>
                                              )
                                            )}
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                );
                              })}
                            </div>
                          ) : (
                            false
                          )}
                          {this.state.activeTab === "flightFare" ? (
                            <div className={"fareContainer"}>
                              <div className="title">{Dictionary.fareTotal}</div>
                              <div className="baseFare">
                                <strong>{Dictionary.baseFare}: </strong>
                                <Price currency={this.props.currency}>
                                  {this.props.itinTotalFare.baseFare}
                                </Price>
                              </div>
                              {this.props.itinTotalFare.totalFee?
                                  <div className="fees">
                                    <strong>{Dictionary.fees}: </strong>
                                    <Price currency={this.props.currency}>
                                      {this.props.itinTotalFare.totalFee}
                                    </Price>
                                  </div>
                               :
                              this.props.itinTotalFare.fess && (this.props.itinTotalFare.fess.length > 0) && (
                                <div className="fees">
                                  <strong>{Dictionary.fees}: </strong>
                                  <Price currency={this.props.currency}>
                                    {this.props.itinTotalFare.fess[0].amount}
                                  </Price>
                                </div>
                              )}
                              {this.props.itinTotalFare.totalTaxes?
                                  <div className="fees">
                                    <strong>{Dictionary.taxes}: </strong>
                                    <Price currency={this.props.currency}>
                                      {this.props.itinTotalFare.totalTaxes}
                                    </Price>
                                  </div>
                               :
                               this.props.itinTotalFare.taxes && (this.props.itinTotalFare.taxes.length > 0) && (<div className="taxes">
                                <strong>{Dictionary.taxes}: </strong>
                                <Price currency={this.props.currency}>
                                  {this.props.itinTotalFare.taxes[0].amount}
                                </Price>
                              </div>)}
                              {this.props.hasExtraBaggage && 
                              <div className="extraBaggage">
                                <strong>{Dictionary.extraBaggage}: </strong>
                                <Price currency={this.props.currency}>
                                  {this.props.itinTotalFare.extraBaggage}
                                </Price>
                              </div>                      
                              }
                              <hr />
                              <div className="totalPrice">
                                <strong>{Dictionary.totalPrice}: </strong>
                                <Price currency={this.props.currency}>
                                  {this.props.itinTotalFare.totalFare}
                                </Price>
                              </div>

                              {this.props.hasExtraBaggage && <div className="totalPrice">
                                <strong>{Dictionary.totalFareWithExtraBaggage}: </strong>
                                <Price currency={this.props.currency}>
                                  {this.props.itinTotalFare.totalFareWithExtraBaggage}
                                </Price>
                              </div>}
                            </div>
                          ) : (
                            false
                          )}
                          {this.state.activeTab === "flightRules" ? (
                            <div className="rules-container">
                              {this.state.rulesContent ? (
                                <>
                                  {this.state.rulesContent.flightRules.length === 0 ? (
                                    <div>{Dictionary.informationNotFound}</div>
                                  ) : (
                                    <>
                                      {this.state.rulesContent.flightRules.map(
                                        (item, index) => {
                                          return (
                                            <div
                                              className="rules-item en-font"
                                              key={index}
                                            >
                                              <div className="rule-title">
                                                FareBase: {item.fareBase}
                                              </div>
                                              <Collapse>
                                                {item.flightRule.map(
                                                  (itemIn, indexIn) => {
                                                    return (
                                                      <Panel
                                                        header={itemIn.ruleTitle}
                                                        key={indexIn}
                                                      >
                                                        <p>{itemIn.ruleDescription}</p>
                                                      </Panel>
                                                    );
                                                  }
                                                )}
                                              </Collapse>
                                            </div>
                                          );
                                        }
                                      )}
                                    </>
                                  )}
                                </>
                              ) : (
                                <div>
                                  {Dictionary.loadingData}
                                  <span className="dots-loading">
                                    <span className="dot">.</span>
                                    <span className="dot">.</span>
                                    <span className="dot">.</span>
                                  </span>
                                </div>
                              )}
                            </div>
                          ) : (
                            false
                          )}

                          {this.state.activeTab === "domesticRefundRules" ? (
                            <div className="rules-container">
                              {this.state.domesticRefundRules ? (
                                <>
                                  {this.state.domesticRefundRules.length === 0 ? (
                                    <div>{Dictionary.informationNotFound}</div>
                                  ) : (
                                    <>
                                      {this.state.domesticRefundRules[0].type=== 1 && <h5 className="normal-title margin-bottom-large">درصد جریمه استرداد بلیط بر اساس زمان اعلام کنسلی</h5>}
                                      {this.state.domesticRefundRules.map(
                                        (item,index) =><div className="margin-bottom" key={index}>
                                          {item.type===1 && <span className="purple font-20 inline-block margin-end" dir="ltr">{item.damage}%</span>}
                                          <span className="inline-block">{item.description}</span>
                                        </div>
                                      )}
                                    </>
                                  )}
                                </>
                              ) : (
                                <div>
                                  {Dictionary.loadingData}
                                  <span className="dots-loading">
                                    <span className="dot">.</span>
                                    <span className="dot">.</span>
                                    <span className="dot">.</span>
                                  </span>
                                </div>
                              )}
                            </div>
                          ) : (
                            false
                          )}

                        </div>
                        <div className="hidden-medium hidden-large">
                        </div>
                      </div>
                  </div>              
                  //---------end
                  :
                    <FlightItinerary model={this.props.model} />               
                  }
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="button color-1-btn"
                onClick={this.closeItinerariModal}
              >
                {Dictionary.ok}
              </button>
            </div>
          </div>
        </div>
        <div className="ticket-style-section flightdetails ">
          <div className="hr_padding">
            <h5 className="normal-title">{Dictionary.priceDetails}</h5>
            <div className="prices-info">
              {this.props.fareInfo !== null && (
                <Collapse bordered={false} defaultActiveKey={[null]}>
                  {this.props.hasExtraBaggage && this.props.passengerInformation ?
                  this.props.passengerInformation.map((passengerItem,passengerIndex)=>this.showEachPassenger(
                    passengerIndex,
                    passengerItem.type,
                    passengerItem.services.extraBaggage
                  ))
                  :
                   this.props.fareInfo.map((item, index) => {
                    return (
                      <Panel
                        className="PassengerType"
                        header={this.showPassenger(
                          item.passengerTypeQuantity.quantity,
                          item.passengerTypeQuantity.code,
                          // %%%extra this.props.extraBaggageIsSelected ? item[this.props.feild].totalFareWithExtraBaggage :
                           item[this.props.feild].totalFare
                        )}
                        key={index}
                      >
                        <div className="pair-row baseFare gray">
                          <div>{Dictionary.baseFare}: </div>
                          <div dir="ltr">
                            <Price currency={this.props.currencyCode}>
                              {item[this.props.feild].baseFare}
                            </Price>
                          </div>
                        </div>
                        <div className="pair-row taxes gray">
                          <div>{Dictionary.taxes}:</div>
                          <div dir="ltr">
                            <Price currency={this.props.currencyCode}>
                              {item[this.props.feild].totalTaxes
                                ? item[this.props.feild].totalTaxes
                                : _.sumBy(
                                    item[this.props.feild].taxes,
                                    (item) => item.amount
                                  )}
                            </Price>
                          </div>
                        </div>

                        {/* %%%extra {this.props.extraBaggageIsSelected ? <div className="pair-row baseFare gray">
                          <div>{Dictionary.extraBaggage}: </div>
                          <div dir="ltr">
                            <Price currency={this.props.currencyCode}>
                              {item[this.props.feild].extraBaggage}
                            </Price>
                          </div>
                        </div>:null} */}


                      </Panel>
                    );
                  })}
                </Collapse>
              )}
            </div>
            {(flightType || noBaggageElement) && <div className="summary-flight-type-row">
              {flightType}
              {noBaggageElement}
            </div>}
            
            <div className="totalPrice inli">
              <div className="pair-row priceCur">
                <strong className="font-14">{Dictionary.totalPrice}:</strong>
                <div>
                  <b>
                    <Price currency={this.props.currencyCode}>
                      {this.props.hasExtraBaggage ? this.props.calculatedTotalPriceWithExtraBaggage:this.props.totalPrice}
                    </Price>
                  </b>
                </div>
              </div>
              {this.props.showButton && (
                <div>
                  <button disabled={this.props.disabledButton} className={`button ${isStyle3?"yellow-btn pale":"red-btn"} full-width has-arrow thick-btn`}>
                    {Dictionary.continueToPayment}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  Dictionary: state.VisualData.Dictionary,
  LAN: state.VisualData.LAN,
});
const mapDispatchToProps = (dispatch) => ({
  showError: (param) => dispatch(showError(param))
});
export default connect(mapStateToProps,mapDispatchToProps)(FlighSummary);
